import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "utils/api";
import {
  clearTokens,
  getAccessToken,
  refreshAccessToken,
  setAccessToken,
  setRefreshToken,
} from "utils/tokenService";
// userActions.js
export const userLogin = createAsyncThunk(
  "user/login",
  async ({ username, password }, thunkAPI) => {
    try {
      const machineId = localStorage.getItem("machineId");
      const { data } = await api.post("/api/token/", {
        username,
        password,
        machine_id: machineId || undefined,
      });

      const { dispatch } = thunkAPI;
      setAccessToken(data.access);
      setRefreshToken(data.refresh);
      dispatch(getUser());
      return { data, accessToken: data.access };
    } catch (err) {
      const message = err.response?.data || err.message || "Login failed";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getUser = createAsyncThunk(
  "api/account/me",
  async (_, thunkAPI) => {
    try {
      const { data } = await api.get("/api/userinfo");
      localStorage.setItem("user", JSON.stringify({ ...data }));
      return { ...data };
    } catch (err) {
      const message = err.response?.data || err.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const cap_table_page = createAsyncThunk(
  "cap_table_page",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("cap_table_page", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const jobCard_page = createAsyncThunk(
  "jobcard_page",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("jobcard_page", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const jobCard_pageComplete = createAsyncThunk(
  "jobcard_page_complete",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("jobcard_page_complete", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Sort_jobCard = createAsyncThunk(
  "Sort_jobCard",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Sort_jobCard_completed = createAsyncThunk(
  "Sort_jobCard_completed",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Client_filter = createAsyncThunk(
  "Client_filter",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("Client_filter", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Client_filter_completed = createAsyncThunk(
  "Client_filter_completed",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("Client_filter", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Stage_filter = createAsyncThunk(
  "Stage_filter",
  async (username, thunkAPI) => {
    try {
      // configure header's Content-Type as JSON

      console.log("Stage_filter", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const Jobid_filter = createAsyncThunk(
  "Jobid_filter",
  async (jobids, thunkAPI) => {
    try {
      console.log("Jobid_filter", jobids);
      return jobids;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const checkAuth = createAsyncThunk(
  "api/account/verify",
  async (_, thunkAPI) => {
    const access = getAccessToken();
    if (!access) return thunkAPI.rejectWithValue("No token");

    const verifyToken = async (token) => {
      return api.post("/api/token/verify/", { token });
    };

    try {
      await verifyToken(access);
      thunkAPI.dispatch(getUser());
      return { token: access };
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        try {
          const refreshed = await refreshAccessToken();
          await verifyToken(refreshed);
          thunkAPI.dispatch(getUser());
          return { token: refreshed };
        } catch (refreshError) {
          clearTokens();
          return thunkAPI.rejectWithValue(
            refreshError.response?.data || "Session expired"
          );
        }
      }
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const Created_by_filter = createAsyncThunk(
  "Created_by_filter",
  async (username, thunkAPI) => {
    try {
      console.log("Created_by_filter", username);
      return username;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const Date_filter = createAsyncThunk(
  "Date_filter",
  async (date, thunkAPI) => {
    try {
      console.log("Date_filter", date);
      return date;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const Jobid_filter_completed = createAsyncThunk(
  "Jobid_filter_completed",
  async (jobids, thunkAPI) => {
    try {
      console.log("Jobid_filter_completed", jobids);
      return jobids;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const Embridary_placement_front_filter_completed = createAsyncThunk(
  "Embridary_placement_front_filter_completed",
  async (value, thunkAPI) => {
    try {
      console.log("Embridary_placement_front_filter_completed", value);
      return value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const Embridary_placement_front_filter = createAsyncThunk(
  "Embridary_placement_front_filter",
  async (value, thunkAPI) => {
    try {
      console.log("Embridary_placement_front_filter", value);
      return value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

// initialize userToken from local storage
const userToken = getAccessToken() || null;

const initialState = {
  loading: true,
  user: null,
  userToken,
  success: false,
  isAuthenticated: false,
  error: null,
  loginStatus: "",
  loginError: "",
  cap_table_page: 1,
  jobcard_page: 1,
  jobcard_page_complete: 1,
  digitizer_page: 1,
  client_filter: "",
  client_filter_completed: "",
  stage_filter: "",
  jobid_filter: "",
  jobid_filter_completed: "",
  embridary_placement_front_filter: "",
  embridary_placement_front_filter_completed: "",
  sort_job: "id",
  sort_job_completed: "id",
  created_by: "",
  date: "", 
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setDigitizerPage(state, action) {
      const nextPage = Number(action.payload) || 1;
      console.log("Reducer hit:", nextPage, "type:", typeof nextPage);
      state.digitizer_page = nextPage;
    },
    setAccessTokenState(state, action) {
      state.userToken = action.payload || "";
      state.isAuthenticated = Boolean(action.payload);
    },
    logout(state) {
      clearTokens();
      localStorage.removeItem("user");
      return {
        ...state,
        userToken: "",
        user: "",
        loading: false,
        cap_table_page: 1,
        isAuthenticated: false,
        jobcard_page: 1,
        jobcard_page_complete: 1,
        client_filter: "",
        stage_filter: "",
        jobid_filter: "",
        jobid_filter_completed: "",
        client_filter_completed: "",
        embridary_placement_front_filter: "",
        embridary_placement_front_filter_completed: "",
        sort_job: "id",
        sort_job_completed: "id",
      };
    },
  },
  extraReducers: (builder) => {
    // login user
    builder
      .addCase(userLogin.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(userLogin.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.userToken = payload.accessToken;
        state.isAuthenticated = true;
      })
      .addCase(userLogin.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      //   get user
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        // state.user = action.payload;
      })
      .addCase(getUser.rejected, (state) => {
        state.loading = false;
      })
      //   check authenticated or not authenticated
      .addCase(checkAuth.pending, (state) => {
        state.checkAuthLoading = true;
      })
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.checkAuthLoading = false;
        state.isAuthenticated = true;
        if (action.payload?.token) {
          state.userToken = action.payload.token;
        }
      })
      .addCase(checkAuth.rejected, (state, action) => {
        state.checkAuthLoading = false;
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.payload;
    })
      .addCase(cap_table_page.fulfilled, (state, action) => {
        state.cap_table_page = action.payload;
      })
      .addCase(jobCard_page.fulfilled, (state, action) => {
        state.jobcard_page = action.payload;
      })
      .addCase(Client_filter.fulfilled, (state, action) => {
        state.client_filter = action.payload;
      })
      .addCase(Client_filter_completed.fulfilled, (state, action) => {
        state.client_filter_completed = action.payload;
      })
      .addCase(Stage_filter.fulfilled, (state, action) => {
        state.stage_filter = action.payload;
      })
      .addCase(Jobid_filter.fulfilled, (state, action) => {
        state.jobid_filter = action.payload;
      })
      .addCase(Sort_jobCard.fulfilled, (state, action) => {
        state.sort_job = action.payload;
      })
      .addCase(Sort_jobCard_completed.fulfilled, (state, action) => {
        state.sort_job_completed = action.payload;
      })
      .addCase(jobCard_pageComplete.fulfilled, (state, action) => {
        state.jobcard_page_complete = action.payload;
      })
      .addCase(Created_by_filter.fulfilled, (state, action) => {
        state.created_by = action.payload;
      })
      .addCase(Date_filter.fulfilled, (state, action) => {
        state.date = action.payload;
        })
      .addCase(Jobid_filter_completed.fulfilled, (state, action) => {
        state.jobid_filter_completed = action.payload;
      })
      .addCase(Embridary_placement_front_filter.fulfilled, (state, action) => {
        state.embridary_placement_front_filter = action.payload;
      })
      .addCase(Embridary_placement_front_filter_completed.fulfilled, (state, action) => {
        state.embridary_placement_front_filter_completed = action.payload;
      });
    // logout
    // .addCase(logout.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(logout.fulfilled, (state) => {
    //   state.loading = false;
    //   state.userToken = false;
    //   state.user = null;
    // })
    // .addCase(logout.rejected, (state) => {
    //   state.loading = false;
    // });
    // register user reducer...
  },
});
// export default userSlice.reducer;

export const { logout, setDigitizerPage, setAccessTokenState } =
  userSlice.actions;

// export default userSlice.reducer;
export default userSlice.reducer;